import { render, staticRenderFns } from "./vsNavItem.vue?vue&type=template&id=aafb76ae"
import script from "./vsNavItem.vue?vue&type=script&lang=js"
export * from "./vsNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports